exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.export {\n  border-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #DBDFE2;\n}\n.export > li {\n    display: inline-block;\n    padding: 0.5rem 0.75rem;\n}\n.export > li .icon {\n      color: #c5d0de;\n}\n.export > li:first-child {\n      border-right: 1px solid #DBDFE2;\n}\n.export > li:hover .icon {\n      color: #8ca0b3;\n      cursor: pointer;\n}\n.export .floating-menu {\n    width: 300%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-10a6deca","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/Export.vue
// module id = 2945
// module chunks = 0